module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alerts"
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasSuccessMessage),
      expression: "hasSuccessMessage"
    }],
    attrs: {
      "title": _vm.messages.success,
      "type": "success",
      "show-icon": ""
    },
    on: {
      "close": function($event) {
        _vm.dismiss('success')
      }
    }
  }), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasErrorMessages),
      expression: "hasErrorMessages"
    }],
    attrs: {
      "title": _vm.formatedErrorMessage,
      "type": "error",
      "show-icon": ""
    },
    on: {
      "close": function($event) {
        _vm.dismiss('error')
      }
    }
  }), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasValidationMessages),
      expression: "hasValidationMessages"
    }],
    attrs: {
      "title": _vm.formatedValidationMessage,
      "type": "warning",
      "show-icon": ""
    },
    on: {
      "close": function($event) {
        _vm.dismiss('validation')
      }
    }
  }), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasWarningMessages),
      expression: "hasWarningMessages"
    }],
    attrs: {
      "title": _vm.messages.warning,
      "type": "warning",
      "show-icon": ""
    },
    on: {
      "close": function($event) {
        _vm.dismiss('warning')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1aba226!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/alerts.vue
// module id = 1639
// module chunks = 32